const CDN = "https://customer-assets.emergentagent.com/job_faster-explosive/artifacts";

// Uploaded brand photography (black & white) — used once each where possible
export const PHOTOS = {
  hero: `${CDN}/a6pv4qk4_IMG_5651.jpeg`, // group training toward camera (cinematic)
  speed: `${CDN}/n90rei35_IMG_5662.jpeg`, // high-knee sprint mechanics
  strength: `${CDN}/tpivlqmj_IMG_5661.jpeg`, // sled push strength
  combine: `${CDN}/ozq7jf4j_IMG_5657.jpeg`, // athlete throwing football
  coach: `${CDN}/zfn4t13f_IMG_5654.jpeg`, // Coach JJ portrait in weight room
  youth: `${CDN}/quvuc450_IMG_5646.jpeg`, // coach leading youth group
};

// Affiliate / worked-with organization logos (full color on black)
export const AFFILIATES = [
  {
    name: "FASST",
    full: "Frisby's Agility, Speed & Strength Training",
    location: "Winchester, VA",
    src: "/fasst.png",
  },
  {
    name: "OG Athletics",
    full: "OG Athletics",
    location: "Wheeling, WV · Ohio Valley",
    src: "/og.png",
  },
  {
    name: "BMP",
    full: "Byron Mitchell Performance",
    location: "Virginia Beach, VA",
    src: "/bmp.png",
  },
  {
    name: "Shenandoah University",
    full: "Shenandoah University Men's Basketball",
    location: "Winchester, VA",
    src: "/shenandoah.png",
  },
];

export const LOGO = "/logo.png";

// Trusted & Affiliated logos (full color, shown on black background)
export const TRUSTED = [
  {
    name: "BMP Football — Byron Mitchell Performance",
    full: "Byron Mitchell Performance",
    location: "Virginia Beach, VA",
    src: "https://customer-assets.emergentagent.com/job_faster-explosive/artifacts/044q48pi_SpeedFactory%20%2811%29.png",
  },
  {
    name: "FASST — Frisby's Agility, Speed & Strength Training",
    full: "Frisby's Agility Speed & Strength Training",
    location: "Winchester, VA",
    src: "https://customer-assets.emergentagent.com/job_faster-explosive/artifacts/folcst1c_SpeedFactory%20%2813%29.png",
  },
];

// Results gallery — real athlete / performance photos (B&W)
export const RESULTS_GALLERY = [
  { src: "https://customer-assets.emergentagent.com/job_faster-explosive/artifacts/qt5xs9bt_IMG_5839.jpeg", alt: "JJ Speed Factory athlete — NCAA All-American", pos: "object-[center_25%]" },
  { src: "https://customer-assets.emergentagent.com/job_faster-explosive/artifacts/2c38m2ow_IMG_5838.jpeg", alt: "Championship relay team on the podium", pos: "object-center" },
  { src: "https://customer-assets.emergentagent.com/job_faster-explosive/artifacts/csgglnbn_IMG_5840.jpeg", alt: "Athlete with NCAA All-American trophy", pos: "object-[center_20%]" },
  { src: "https://customer-assets.emergentagent.com/job_faster-explosive/artifacts/4e1e06sf_IMG_5841.jpeg", alt: "Conference champion on the podium", pos: "object-center" },
];
